export class FiltroMaterial {
  codigoValorCaracteristica: string;
  codigoCaracteristica: string;
  numeroCaracteristica: number;
  siglaUnidadeMedida: string;
}
